import { Checkbox } from "./ui/checkbox";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { useParams, useNavigate } from "react-router-dom";

const CATS = ["Kwantiteit", "Kwaliteit", "Tijdigheid", "Kosten"];
const UNITS = ["Eenheden", "Percentages"];

const parse = (s) => CATS.filter((c) => (s || "").toLowerCase().includes(c.toLowerCase()));

export const PvpCategoryField = ({ label, values, disabled, onChange }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const selected = parse(values.categorie);
  const hasQty = selected.includes("Kwantiteit");
  const unit = values.kwantiteit_eenheid || "";
  const suffix = unit === "Percentages" ? "%" : "";

  const toggle = (c, on) => {
    const next = CATS.filter((x) => (x === c ? on : selected.includes(x)));
    onChange({ ...values, categorie: next.join(", ") });
  };
  const pickUnit = (u) => {
    const pct = u === "Percentages";
    onChange({ ...values, kwantiteit_eenheid: u, ondergrens: pct ? "0" : "", bovengrens: pct ? "100" : "" });
  };
  const bounds = [["ondergrens", "Ondergrens"], ["bovengrens", "Bovengrens"]];
  const n = Number(values.nulmeting_aantal || 0);

  return (
    <div className="space-y-3" data-testid="pvp-field-meetplan-categorie">
      <Label className="text-sm font-medium leading-snug block">{label}</Label>
      <div className="flex flex-wrap gap-x-6 gap-y-2">
        {CATS.map((c) => (
          <label key={c} className="flex items-center gap-2 text-sm cursor-pointer">
            <Checkbox checked={selected.includes(c)} disabled={disabled} onCheckedChange={(v) => toggle(c, !!v)}
              className="rounded-none" data-testid={`pvp-categorie-${c.toLowerCase()}`} />
            {c}
          </label>
        ))}
      </div>
      {hasQty && (
        <div className="border-l-2 border-zinc-900 pl-4 space-y-3" data-testid="pvp-kwantiteit-block">
          <Label className="text-sm font-medium block">Wordt kwantiteit gemeten in eenheden of in percentages?</Label>
          <div className="flex gap-2">
            {UNITS.map((u) => (
              <button key={u} type="button" disabled={disabled} onClick={() => pickUnit(u)}
                className={`px-3 py-1.5 text-sm border transition-colors ${unit === u ? "bg-zinc-900 text-white border-zinc-900" : "border-zinc-400 hover:bg-zinc-100"}`}
                data-testid={`pvp-kwantiteit-${u.toLowerCase()}`}>{u}</button>
            ))}
          </div>
          {unit && (
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl">
              {bounds.map(([k, l]) => (
                <div key={k} className="space-y-1">
                  <Label className="text-xs uppercase tracking-widest font-mono text-zinc-500">{l}{suffix && ` (${suffix})`}</Label>
                  <Input type="number" value={values[k] ?? ""} disabled={disabled}
                    onChange={(e) => onChange({ ...values, [k]: e.target.value })}
                    className="rounded-none border-zinc-400" data-testid={`pvp-${k}`} />
                </div>
              ))}
              <div className="space-y-1" data-testid="pvp-nulmeting-readonly">
                <Label className="text-xs uppercase tracking-widest font-mono text-zinc-500">Nulmeting{suffix && ` (${suffix})`}</Label>
                <div className="h-9 flex items-center border border-dashed border-zinc-300 bg-zinc-50 px-3 text-sm" data-testid="pvp-nulmeting-value">
                  {values.nulmeting_waarde !== undefined && values.nulmeting_waarde !== ""
                    ? <span><span className="font-semibold">{values.nulmeting_waarde}{suffix}</span> <span className="text-zinc-500 text-xs">gem. van {n} {n === 1 ? "nulmeting" : "nulmetingen"}</span></span>
                    : <span className="text-zinc-400">nog geen nulmeting</span>}
                </div>
                <button type="button" onClick={() => navigate(`/pvp/${id}/metingen`)} className="text-xs underline underline-offset-4 text-zinc-600 hover:text-zinc-900" data-testid="pvp-nulmeting-goto">Invoeren via Handmatige invoer</button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
